<template>
  <a-modal title="Select Export Data" :visible="visible" :closable="false" @cancel="closeModal" :destroy-on-close="true"
    ><div class="flex flex-column gap-2" :style="{ maxHeight: '500px', overflow: 'auto' }">
      <p class="table-export-modal__description">
        Select the columns you want to include for each {{ exportEntity }}. Only the columns you select will appear in
        the exported file.
      </p>
      <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"> Check all </a-checkbox>
      <a-checkbox-group
        class="flex flex-column gap-2"
        v-model="checkedList"
        :options="plainOptions"
        @change="onChange"
      />
    </div>
    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="closeModal">Cancel</a-button>
        <a-button
          type="primary"
          @click="
            () => {
              $emit('export', checkedList)
              this.closeModal()
            }
          "
          >Export</a-button
        >
      </div>
    </template>
  </a-modal>
</template>

<script>
import { deepCopy } from '@/utils/deep-copy'
import { Checkbox, Modal } from 'ant-design-vue'

export default {
  components: {
    'a-modal': Modal,
    'a-checkbox': Checkbox,
    'a-checkbox-group': Checkbox.Group
  },
  data() {
    return {
      indeterminate: true,
      checkAll: false,

      checkedList: [],
      plainOptions: []
    }
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    exportEntity: {
      type: String,
      default: 'item'
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.checkedList = deepCopy(this.columns)
        this.plainOptions = deepCopy(this.columns)
        this.indeterminate = false
        this.checkAll = true
      },
      immediate: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:visible', false)
    },
    onChange(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    onCheckAllChange(e) {
      this.checkedList = e.target.checked ? this.plainOptions : []
      this.indeterminate = false
      this.checkAll = e.target.checked
    }
  }
}
</script>

<style scoped>
.table-export-modal__description {
  margin: 0 0 6px;
  color: var(--text-color-secondary);
  white-space: normal;
}
</style>
